var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#8D73B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3387 18.7379C17.0889 18.8965 16.7763 18.9193 16.5062 18.7987C15.9707 18.5017 14.9942 17.7929 13.6397 16.4384C12.2852 15.0839 11.5134 14.0422 11.2142 13.5134C11.0935 13.2433 11.1163 12.9307 11.2749 12.6809L12.0534 11.3174C12.3324 10.8337 12.3954 10.5277 12.0917 10.0574L10.0914 6.99516C9.52219 6.09516 9.23194 6.13566 8.74144 6.36066C6.18994 7.52166 5.19318 9.16416 8.81344 14.8814C9.78994 16.4227 12.7734 19.6852 15.3182 21.3367C20.7677 24.8759 22.5609 23.8117 23.6252 21.3367C23.8502 20.8372 23.9492 20.5469 23.0919 19.9867L19.9959 18.0179C19.5257 17.7164 19.2962 17.6377 18.8102 17.9189L17.3387 18.7379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.59acf8dafe2a72ff0097b1fe16741865.svg";
export { ForwardRef as ReactComponent };